// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__ipCzV","fadeIn":"styles_fadeIn__GJ48k","preview":"styles_preview__xJO0G"};